module.exports = __webpack_public_path__ + "img/01.8aa927a9.png";